import { Card } from '@achieve/ascend'
import { MediaImageStandard, Typography } from 'components/Contentful'
import { BLOCKS } from '@contentful/rich-text-types'
import classNames from 'classnames'

function CardAboutERP({ content, imageWidth = 80, imageHeight = 80 }) {
  const { cardTitleText, cardText, cardImage } = content || {}
  return (
    <Card
      variant="none"
      data-testid="card-container"
      className="bg-blue-50 justify-between items-center text-center max-w-[350px] px-0 py-4 rounded-none"
    >
      {cardImage && (
        <MediaImageStandard
          className="w-[310px] rounded-[10px]"
          content={cardImage}
          data-testid="card-media-image"
          height={imageHeight}
          layout="fixed"
          objectFit="cover"
          width={imageWidth}
        />
      )}
      {cardTitleText && (
        <Typography
          className="text-center mx-0 my-4 px-8 py-0"
          content={cardTitleText}
          data-testid="card-title"
          fontWeight="medium"
          variantOverride={{ [BLOCKS.HEADING_3]: 'headingMd' }}
        />
      )}
      {cardText && (
        <Typography
          className={classNames('text-center mx-0 my-4 px-8 py-0', 'bodySm lg:bodyLg')}
          content={cardText}
          data-testid="card-subtitle"
        />
      )}
    </Card>
  )
}

export { CardAboutERP }
